exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form__row[data-v-e3704462] {\n  margin-top: 0;\n  width: 100%;\n}\n.button-delete[data-v-e3704462] {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  width: 20px;\n  height: 20px;\n}\n@media (min-width: 768px) {\n.form__row[data-v-e3704462] {\n    margin: 0;\n    width: 100%;\n    margin-right: 10px;\n}\n.button-delete[data-v-e3704462] {\n    position: static;\n    flex: none;\n}\n}\n@media (min-width: 1160px) {\n.button-delete[data-v-e3704462] {\n    width: 10px;\n    height: 10px;\n}\n}\n", ""]);

// exports
